import React from 'react';
import ReactMarkdown from 'react-markdown/with-html';

export const title = '​Returns & Refunds Policy';

const contentSource = `
Thank you for your interest in Genrus United. Please read this policy carefully.

We do not issue refunds for memberships once the order is confirmed and your membership card is sent. We recommend contacting us for assistance if you experience any issues receiving your membership.

If you have any questions about our Returns and Refunds Policy, please contact us by email at: membership@genrusunited.ca.
`;

export const content = (
  <ReactMarkdown source={contentSource} escapeHtml />
);
